import { isNil } from 'ramda';

import { ErrorVariant, TransCuriosityLookupProps } from './TransCuriosityLookup.types';
import { LookupErrorMessage, getCuriosityValues } from './TransCuriosityLookup.utils';

export const TransCuriosityLookup = ({
  context,
  ns,
  field,
  delimiter = ', ',
  zero = '-',
  valueGetter,
}: TransCuriosityLookupProps) => {
  if (!field || isNil(context[field])) {
    return <LookupErrorMessage variant={ErrorVariant.FIELD} />;
  }
  if (!ns) {
    return <LookupErrorMessage variant={ErrorVariant.NS} />;
  }

  const values = getCuriosityValues({
    ids: context[field],
    ns,
    delimiter,
    valueGetter,
  });

  return <>{values.length ? values : zero}</>;
};
